<template>
  <div>
    <post :item="post" :addComment="(data) => addPostComment(data)" :addLike="(data) => addPostLike(data)"/>
  </div>
</template>

<script>
import Post from "../components/Post.vue";
export default {
  components: { Post },
  mounted() {
    let id = this.$router.currentRoute.params.id;
    this.getPost(id);
  },
};
</script>

<style></style>
